module.exports = __webpack_public_path__ + "img/play-button.74f2681a.png";